import Layout from "../../layout/layout";
import { useEffect, useState } from "react";
import { useLoader } from "../../context/loaderContext";
import { Appid, BaseUrl, Imei, LoginTypeID, SerialNo, Version } from "../../enum/enum";
import axios from "axios";
import { useAuth } from "../../context/authContext";

const Investment = () => {
    const { showLoader, hideLoader } = useLoader();
    const {
        token,
        sessionId,
        userId,
    } = useAuth();

    const [investmentList, setInvestmentList] = useState([]);
    const [slotId, dsf] = useState([]);

    const getInvestmentList = async () => {
        try {
            showLoader();

            const url = `${BaseUrl}Dashboard/SelfBusiness`;

            const obj = {
                "Request": {
                },
                "appSession": {
                    "appid": Appid,
                    "imei": Imei,
                    "isSeller": false,
                    "loginTypeID": LoginTypeID,
                    "regKey": "",
                    "serialNo": SerialNo,
                    "session": token,
                    "sessionID": sessionId,
                    "userID": userId,
                    "version": Version
                }
            }

            showLoader();

            const res = await axios.post(url, obj);

            if (res.data?.statuscode == 1) {
                setInvestmentList(res.data.data || []);
            }

            hideLoader();
        } catch (e) {
            hideLoader();
            console.log("Inves Error: ", e.message);
        }
    }

    useEffect(() => {
        getInvestmentList();
    }, []);

    return (
        <Layout>
            <main>
                <div className="pageWrapper maxWidth pt-0">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="desktop-card card">
                                    <div className="card-header">
                                        <h5> Stake Report </h5>
                                    </div>
                                    <div className="desktop-view-only card-body px-0">
                                        <div className="table-responsive">
                                            <table className="table align-middle mb-0 bg-hover-effect">
                                                <thead>
                                                    <tr>
                                                        <th scope="col">#</th>
                                                        <th scope="col">Currency</th>
                                                        <th scope="col">Amount</th>
                                                        <th scope="col">Date</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {investmentList?.length > 0 ?
                                                        investmentList?.map((el, i) => (
                                                            <tr key={i}>
                                                                <td>{i + 1}</td>
                                                                <td>
                                                                    <p className="mb-0 f-w-500 ">{el.businessCurrency}</p>
                                                                </td>
                                                                <td className="f-w-600">${el.packageCost}</td>
                                                                <td><span className=" ">{el.businessDate}</span></td>
                                                            </tr>
                                                        )) : (
                                                            <tr>
                                                                <td colSpan={7} className="text-center">No records found.</td>
                                                            </tr>
                                                        )}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div className="mobile-view-only">
                                        {investmentList?.length > 0 ? (
                                            investmentList.map((el, i) => (
                                                <div key={i} className={"card mb-3 p-3 bg-hover-effect rounded shadow-sm "}>
                                                    <div className="d-flex justify-content-between align-items-center my-2">
                                                        <span className="badge bg-dark">#{i + 1}</span>
                                                    </div>

                                                    <div className="d-flex justify-content-between align-items-center my-2">
                                                        <strong>Currency:</strong>
                                                        <p className="mb-0 f-w-500">{el.businessCurrency}</p>
                                                    </div>

                                                    <div className="d-flex justify-content-between align-items-center my-2">
                                                        <strong>Amount:</strong>
                                                        <p className="mb-0 f-w-600">${el.packageCost}</p>
                                                    </div>

                                                    <div className="d-flex justify-content-between align-items-center my-2">
                                                        <strong>Date:</strong>
                                                        <span className="badge bg-info text-white">{el.businessDate}</span>
                                                    </div>
                                                </div>
                                            ))
                                        ) : (
                                            <p className="text-center">No records found.</p>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </Layout>
    )
}

export default Investment;